import { render, staticRenderFns } from "./AtomPartner.vue?vue&type=template&id=a060c2b4&scoped=true&"
import script from "./AtomPartner.vue?vue&type=script&lang=js&"
export * from "./AtomPartner.vue?vue&type=script&lang=js&"
import style0 from "./AtomPartner.vue?vue&type=style&index=0&id=a060c2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a060c2b4",
  null
  
)

export default component.exports